<div>
  <svg-icon name="logo"
            size="70"></svg-icon>
  <div class="circle"></div>
</div>
